export default __webpack_public_path__ + "34cbc85e7b2159474edf46422b7762f7.svg";